module.exports = __webpack_public_path__ + "img/detail-4.5945ce49.jpg";